import { vueAppWithPinia } from "../Common/vueApp";

import AnnouncerBoardApp from "./AnnouncerBoardApp.vue";

export default vueAppWithPinia(AnnouncerBoardApp);
